// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__sGXTD","loaderOuter":"PageOverlayLoader_loaderOuter__1uP2b"};